<template>
    <div>
        <p>合計</p>
        <div id="DamageStatsContainer">   
            <DamageStat v-for="damage in DamageTypes" :key="damage.Count" :Label="damage.Type" :Count="damage.Count" />
        </div>
        <div style="height: 20px; width: 1px;"></div>
        <GenericDropdown :elementID="'ReturnedItemsDropdown'" :options="ProductOptions" :OnChange="OnProductChanged" />
        <div style="height: 20px; width: 1px;"></div>
        <div v-if="Products.length > 0" id="DamageContainer">
            <ReturnedItemDamage v-for="damage in Products[SelectedProduct].cases" :key="damage.category" :DamageCategory="damage.category" :Remark="damage.remark" />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import GenericDropdown from '@/components/GenericDropdown.vue';
import ReturnedItemDamage from '@/components/ReturnedItemDamage.vue';
import DamageStat from '@/components/DamageStat.vue';
export default{
    components:{
        GenericDropdown,
        ReturnedItemDamage,
        DamageStat,
    },
    mounted(){
        this.GetReturnedItems();
    },
    methods:{
        async GetReturnedItems()
        {
            const param = {
                SessionToken: this.$GetToken(),
            };

            const result = await axios.post(`${process.env.VUE_APP_BACKEND_URL}returneditems`, param)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error;
            });

            console.log('returned products', result);

            this.Products = [];
            this.ProductOptions = [];
            this.DamageTypes = [];

            // It's late and I don't have much time,
            // just quick and dirty. Should be done
            // all in one for-loop
            for (let i = 0; i < result.length; i++)
            {
                const p = result[i];
                let damageData = null;
                for (let j = 0; j < this.DamageTypes.length; j++)
                {
                    if (this.DamageTypes[j].Type === p.DamageCategory)
                    {
                        damageData = this.DamageTypes[j];
                        break;
                    }
                }

                if (damageData === null)
                {
                    damageData = {
                        Type: p.DamageCategory,
                        Count: 1,
                    };
                    
                    this.DamageTypes.push(damageData);
                }
                else
                {
                    damageData.Count++;
                }
            }

            for (let i = 0; i < result.length; i++)
            {
                const p = result[i];
                let productData = null;
                for (let j = 0; j < this.Products.length; j++)
                {
                    if (this.Products[j].stylenumber === p.productCode)
                    {
                        productData = this.Products[j];
                        break;
                    }
                    
                }

                if (productData === null)
                {
                    productData = {
                        id: p.id,
                        name: p.productName,
                        stylenumber: p.productCode,
                        cases:[]
                    };
                    this.Products.push(productData);
                    this.ProductOptions.push({label: `${productData.stylenumber} | ${productData.name}`, value: productData.id});
                }

                productData.cases.push({
                    category: p.DamageCategory,
                    remark: p.remarks
                });
            }

            console.log('Prepared products ', this.Products);
            console.log('Prepared options ', this.ProductOptions);
            console.log('Damage stats', this.DamageTypes);
        },
        OnProductChanged(event)
        {
            this.SelectedProduct = event.target.selectedIndex;
        }
    },
    data(){
        return{
            SelectedProduct: 0,
            ProductOptions: [],
            Products: [],
            DamageTypes: []
        }
    }
}
</script>

<style>
#DamageContainer
{
    width: 80%;
    padding-left: 10px;
}

#DamageStatsContainer
{
    display: flex;
}
</style>